import React, { useState, useEffect } from 'react';
import DigitalLibrary from '../../images/DigitalLibrary.png';
import DigitalBook from '../../images/DigitalBook.png';
import {
    ModalContainer,
    ModalHeader,
    ModalFooter,
    ModalFormLabel,
    ModalTextArea,
    ModalCloseButton,
    ModalButton,
    ProductRow,
    ProductImageWrap,
    ProductImage,
    ProductDetailWrapper,
    ProductPageModalOverlay,
    ProductDescriptionText,
    ProductCost,
    SpinningIcon,
} from './ProductElements';

const ProductPageModal = ({ isOpen, onClose, setSelectedProduct, gift }) => {


    const [loadingBoolean, setLoadingBoolean] = useState(false);

    const handleClose = () => {
        onClose();
    }

    const handleSetSelectedProduct = async (e, selectedProduct) => {
        setLoadingBoolean(true);
        setSelectedProduct(e, selectedProduct);
        setLoadingBoolean(false);
    };

    if (!isOpen) return null;

    return (
        <ProductPageModalOverlay>
            <ModalContainer >
                <ModalHeader>Select Your Product</ModalHeader >
                {gift === true && (
                    <ProductRow>
                        <ProductImageWrap>
                            <ProductImage src={DigitalBook} />
                        </ProductImageWrap>
                        <ProductDetailWrapper>
                            <ModalFormLabel> Free Book </ModalFormLabel>
                            <ProductDescriptionText>Select this product to make a one time digital book purchase. This gives you the ability to create and modify the specific digital book you are currently creating.</ProductDescriptionText>
                            <ProductCost readOnly >$0.00 (One Time)</ProductCost>
                            <ModalButton onClick={(e) => setSelectedProduct(e, 'FreeGift')}>Select</ModalButton>
                        </ProductDetailWrapper>
                    </ProductRow>
                )
                }
                <ProductRow>
                    <ProductImageWrap>
                        <ProductImage src={DigitalLibrary} />
                    </ProductImageWrap>
                    <ProductDetailWrapper>
                        <ModalFormLabel> Monthly Subscription </ModalFormLabel>
                        <ProductDescriptionText>Select this product to sign up and purchase a Stories We Feel monthly subscription. This gives you acceess to all the titles in your digital library and allows you to create new digital works at will.</ProductDescriptionText>
                        <ProductCost readOnly>$6.00 (Monthly)</ProductCost>
                        <>
                            {loadingBoolean && (
                                <SpinningIcon />
                            )}
                            <ModalButton disabled={!!loadingBoolean} onClick={(e) => handleSetSelectedProduct(e, 'Subscription')}>Select</ModalButton>
                        </>
                    </ProductDetailWrapper>
                </ProductRow>
                <ProductRow>
                    <ProductImageWrap>
                        <ProductImage src={DigitalBook} />
                    </ProductImageWrap>
                    <ProductDetailWrapper>
                        <ModalFormLabel> Single Purchase </ModalFormLabel>
                        <ProductDescriptionText>Select this product to make a one time digital book purchase. This gives you the ability to create and modify the specific digital book you are currently creating.</ProductDescriptionText>
                        <ProductCost readOnly >$4.00 (One Time)</ProductCost>
                        <>
                            {loadingBoolean && (
                                <SpinningIcon />
                            )}
                            <ModalButton disabled={!!loadingBoolean} onClick={(e) => handleSetSelectedProduct(e, 'SinglePurchase')}>Select</ModalButton>
                        </>
                    </ProductDetailWrapper>
                </ProductRow>
                <ModalFooter>
                    <ModalCloseButton onClick={handleClose}>Close</ModalCloseButton>
                </ModalFooter>
            </ModalContainer>
        </ProductPageModalOverlay >
    );
};


export default ProductPageModal;
